import { Button, Container, Grid,useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import ContentList from "../../components/contentList";
import { useDispatch } from "react-redux";
import letterOfInterest from "../../../../assets/documents/Letter_of_Interest.pdf";
import { setTabPosition } from "../../uiSlice";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  img: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },

  videoContainer: {
      paddingLeft: 50
  }
}));

export default function Scan2PayContent() {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const dispatch = useDispatch();


  return (
    <Container className={classes.root}>
        <Grid container direction="row">
        {xs && (
         <Grid container direction="column" xs={12} sm={7}>  
        <Grid item > 
        <ContentList
        title ='WHO CAN YOOZ IT?'
        items = {[
          <span>
            Wondering if your business or organization can benefit from YOOZ Scan2Pay? The answer is YES!    
          </span>,
          <span>
            It's perfect for any business, non-profit or religious organization, as well as events and fundraisers. 
          </span>
        ]}
        
        />
        </Grid>
        <Grid item >  
        <ContentList
            title="HOW DOES IT WORK?"
            items ={[
                <span>
                    With <span style={{color:"#cb010d",fontWeight:"bold"}}>YOOZ Scan2Pay</span>, we give you a unique, 
                    secure <b> YOOZ QR Code</b> and <b>YOOZ URL Link</b>. Display the code so your customers
                     can scan it or share the link via social media, WhatsApp or email. 
                     When the customer scans the code or clicks the link, 
                     they are carried to our secure payment portal 
                     where they can use their credit cards or Visa debit cards to pay.
                      Once the transaction is successful, 
                      both of you immediately receive an e-receipt 
                      so you and your sales staff can track the transaction. 
                </span>    
            ]}
        />
        </Grid>
        {xs && (
        <Grid item  >
        <iframe
            title="topup video"
            width={xs ? "100%":500}
            height={xs ? 300:500}
            src="https://www.youtube.com/embed/JJuDwVzxZBE"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            class={classes.videoContainer}
          ></iframe>
      
      </Grid>
        )}  
        
          
          <ContentList 
            title="HOW MUCH DOES IT COST?"
            items ={[
                <span>
                   We operate on a per transaction pricing model, which means you only pay when you get paid! 
                </span>,
                <span>
                     Our standard transaction fees are 3% (bank fees) + $5.00 per transaction. 
                </span>    
            ]}

        />
        <ContentList
            title="READY TO GET STARTED?"
            items ={[
               <span>
                  Call the <span style={{color:"#cb010d",fontWeight:"bold"}}>YOOZ Scan2Pay</span> team at 235-6182 or <a href={letterOfInterest} target="_blank">click</a> to download the letter of interest and email it to <a href="mailto: yooz@yoozit.today">yooz@yoozit.today</a>. 
                </span>
                
            ]}

        />
        </Grid>
        )}
            {sm && (
         <Grid container direction="column" xs={12} sm={7}>  
         <Grid item > 
        <ContentList
        title ='WHO CAN YOOZ IT?'
        items = {[
          <span>
            Wondering if your business or organization can benefit from YOOZ Scan2Pay? The answer is YES!    
          </span>,
          <span>
            It's perfect for any business, non-profit or religious organization, as well as events and fundraisers. 
          </span>
        ]}
        
        />
        </Grid>
        <Grid item  >  
        <ContentList
            title="HOW DOES IT WORK?"
            items ={[
                <span>
                    With <span style={{color:"#cb010d",fontWeight:"bold"}}>YOOZ Scan2Pay</span>, we give you a unique, 
                    secure <b> YOOZ QR Code</b> and <b>YOOZ URL Link</b>. Display the code so your customers
                     can scan it or share the link via social media, WhatsApp or email. 
                     When the customer scans the code or clicks the link, 
                     they are carried to our secure payment portal 
                     where they can use their credit cards or Visa debit cards to pay.
                      Once the transaction is successful, 
                      both of you immediately receive an e-receipt 
                      so you and your sales staff can track the transaction. 
                </span>    
            ]}
        />
        </Grid>
       
        
          
          <ContentList
            title="HOW MUCH DOES IT COST?"
            items ={[
                <span>
                   We operate on a per transaction pricing model, which means you only pay when you get paid! 
                </span>,
                <span>
                     Our standard transaction fees are 3% (bank fees) + $5.63 per transaction. Settlements are remitted via ACH at a cost of $1.00 per transfer. 
                </span>    
            ]}

        />
        <ContentList
            title="READY TO GET STARTED?"
            items ={[
                <span>
                  Call the <span style={{color:"#cb010d",fontWeight:"bold"}}>YOOZ Scan2Pay</span> team at 235-6182 or <a href="https://www.dropbox.com/s/ig16n367sg6dvl5/Letter_of_Interest.pdf?dl=1" target="_blank">click</a> to download the letter of interest and email it to <a href="mailto: yooz@yoozit.today">yooz@yoozit.today</a>. 
                </span>
                
            ]}

        />
        </Grid>
        )}
        {sm && (
        <Grid container direction="columm" xs={6} sm={5}>
        <iframe
            title="topup video"
            width={xs ? "100%":500}
            height={xs ? 300:500}
            src="https://www.youtube.com/embed/JJuDwVzxZBE"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            class={classes.videoContainer}
          ></iframe>
        </Grid>
        )}
        </Grid>
    </Container>
  );


}
